import { render } from "./MatrixUploader.vue?vue&type=template&id=5229e1ce&scoped=true"
import script from "./MatrixUploader.vue?vue&type=script&lang=js"
export * from "./MatrixUploader.vue?vue&type=script&lang=js"

import "./MatrixUploader.vue?vue&type=style&index=0&id=5229e1ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5229e1ce"]])

export default __exports__